/**
 * @generated SignedSource<<990423f9e69c8f446718a2fd8a0a7447>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateMediaFactoryEditorEmbedInput = {
  appId?: number | null;
};
export type aiCustomAppsCreateMediaFactoryEditorEmbedMutation$variables = {
  input: CreateMediaFactoryEditorEmbedInput;
};
export type aiCustomAppsCreateMediaFactoryEditorEmbedMutation$data = {
  readonly createMediaFactoryEditorEmbed: {
    readonly editorUrl: string;
    readonly expiresAt: string | null;
    readonly jti: string;
    readonly sdkUrl: string;
    readonly token: string;
    readonly workflowExternalId: string | null;
  };
};
export type aiCustomAppsCreateMediaFactoryEditorEmbedMutation = {
  response: aiCustomAppsCreateMediaFactoryEditorEmbedMutation$data;
  variables: aiCustomAppsCreateMediaFactoryEditorEmbedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MediaFactoryEmbedPayload",
    "kind": "LinkedField",
    "name": "createMediaFactoryEditorEmbed",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jti",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expiresAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "editorUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sdkUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowExternalId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "aiCustomAppsCreateMediaFactoryEditorEmbedMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "aiCustomAppsCreateMediaFactoryEditorEmbedMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "59744453c620da38387ce1fca58ce808",
    "id": null,
    "metadata": {},
    "name": "aiCustomAppsCreateMediaFactoryEditorEmbedMutation",
    "operationKind": "mutation",
    "text": "mutation aiCustomAppsCreateMediaFactoryEditorEmbedMutation(\n  $input: CreateMediaFactoryEditorEmbedInput!\n) {\n  createMediaFactoryEditorEmbed(input: $input) {\n    token\n    jti\n    expiresAt\n    editorUrl\n    sdkUrl\n    workflowExternalId\n  }\n}\n"
  }
};
})();

(node as any).hash = "5085c3a654128fe5f32b1ca4d74af971";

export default node;
